import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

interface StoredReportSession {
  accessToken: string;
  expiresAt: number;
}

@Injectable({ providedIn: 'root' })
export class PublicReportSessionStore {
  private readonly invalidatedSubject = new Subject<string>();
  readonly invalidated$ = this.invalidatedSubject.asObservable();

  store(reportToken: string, accessToken: string, expiresInSeconds: number): void {
    sessionStorage.setItem(
      this.key(reportToken),
      JSON.stringify({ accessToken, expiresAt: Date.now() + expiresInSeconds * 1000 }),
    );
  }

  getValid(reportToken: string): string | null {
    try {
      const raw = sessionStorage.getItem(this.key(reportToken));
      if (!raw) return null;
      const value = JSON.parse(raw) as StoredReportSession;
      if (!value.accessToken || value.expiresAt <= Date.now()) {
        this.clear(reportToken);
        return null;
      }
      return value.accessToken;
    } catch {
      this.clear(reportToken);
      return null;
    }
  }

  clear(reportToken: string): void {
    sessionStorage.removeItem(this.key(reportToken));
  }

  invalidate(reportToken: string): void {
    this.clear(reportToken);
    this.invalidatedSubject.next(reportToken);
  }

  tokenFromUrl(url: string): string | null {
    const match = url.match(/\/public\/report\/([^/?]+)/);
    return match ? decodeURIComponent(match[1]) : null;
  }

  private key(reportToken: string): string {
    return `publicReportSession:${reportToken}`;
  }
}
